var _toConsumableArray = require("/home/br/src/my/fp-snake-game/node_modules/@babel/runtime/helpers/toConsumableArray");

var _ = require("lodash");

var fp = require("lodash/fp");

var p = require("fp-panel"); // Configuration


var GLOBAL = {
  color: "grey",
  appleColor: "red",
  snakeColor: "orange"
}; // Paint

var paintApple = function paintApple(panel) {
  return p.paint(panel, [{
    row: _.random(0, panel.length - 1),
    column: _.random(0, panel[0].length - 1)
  }], GLOBAL.appleColor);
};

var paintSnake = function paintSnake(panel) {
  return p.paint(panel, [{
    row: _.random(0, panel.length - 1),
    column: _.random(0, panel[0].length - 1),
    key: 0
  }], GLOBAL.snakeColor);
}; // Panel


var createPanel = function () {
  var savedRows = 0;
  var savedColumns = 0;
  return function (rows, columns) {
    savedRows = rows ? rows : savedRows;
    savedColumns = columns ? columns : savedColumns;
    return p.createPanel(savedRows, savedColumns);
  };
}();

var createApplePanel = function () {
  var savedRows = 0;
  var savedColumns = 0;
  return function (rows, columns) {
    savedRows = rows ? rows : savedRows;
    savedColumns = columns ? columns : savedColumns;
    return paintApple(createPanel(savedRows, savedColumns));
  };
}();

var createSnakePanel = function () {
  var savedRows = 0;
  var savedColumns = 0;
  return function (rows, columns) {
    savedRows = rows ? rows : savedRows;
    savedColumns = columns ? columns : savedColumns;
    return paintSnake(createPanel(savedRows, savedColumns));
  };
}(); // For snake


var LEFT = "left";
var UP = "up";
var RIGHT = "right";
var DOWN = "down";

var matchKey = function matchKey(akey, bkey) {
  return akey === bkey ? 1 : 0;
};

var getNewRowColumn = function getNewRowColumn(headItem, key) {
  return {
    row: headItem.row - matchKey(key, UP) + matchKey(key, DOWN),
    column: headItem.column - matchKey(key, LEFT) + matchKey(key, RIGHT)
  };
};

var addHeadItem = function addHeadItem(ary) {
  var snake = _.cloneDeep(ary);

  var headItem = _.cloneDeep(_.head(snake));

  var newHeadItem = _.assign(headItem, getNewRowColumn(headItem, headItem.key));

  return [newHeadItem].concat(_toConsumableArray(snake));
};

var removeTailItem = _.initial;

var reIndexing = function reIndexing(ary) {
  return ary.map(function (item, index) {
    item.index = index;
    return item;
  });
};

var justPaintSnake = function justPaintSnake(posAry) {
  return p.paint(createPanel(), posAry, GLOBAL.snakeColor);
};

var moveSnake = _.flow([_.flattenDepth, fp.filter(p.isItem), fp.sortBy("index"), addHeadItem, reIndexing, removeTailItem, justPaintSnake]);

var moveSnakeAndAddTail = _.flow([_.flattenDepth, fp.filter(p.isItem), fp.sortBy("index"), addHeadItem, reIndexing, justPaintSnake]);

var getSnake = _.flow([_.flattenDepth, fp.filter(p.isItem)]);

var addCount = function addCount(_ref) {
  var applePanel = _ref.applePanel,
      snakePanel = _ref.snakePanel;
  _.last(_.last(applePanel)).count = getSnake(snakePanel).length;
  return {
    applePanel: applePanel,
    snakePanel: snakePanel
  };
};

var updatePanel = function updatePanel(_ref2) {
  var applePanel = _ref2.applePanel,
      snakePanel = _ref2.snakePanel;
  var outOfRange = nextItemIsOutOfRange(snakePanel, getHeadItem(snakePanel).key);
  var tempSnakePanel = outOfRange ? snakePanel : moveSnake(snakePanel);
  var overlap = p.isOverlap(applePanel, tempSnakePanel);
  var newApplePanel = overlap ? createApplePanel() : applePanel;
  var newSnakePanel = overlap ? moveSnakeAndAddTail(snakePanel) : tempSnakePanel;
  return addCount({
    applePanel: newApplePanel,
    snakePanel: newSnakePanel
  });
}; // Check functions


var getHeadItem = _.flow([_.cloneDeep, _.flattenDepth, fp.filter(p.isItem), fp.sortBy("index"), _.head]);

var getNextItem = function getNextItem(snakePanel, key) {
  var headItem = getHeadItem(snakePanel);

  var _getNewRowColumn = getNewRowColumn(headItem, key),
      row = _getNewRowColumn.row,
      column = _getNewRowColumn.column;

  return snakePanel && snakePanel[row] && snakePanel[row][column] ? snakePanel[row][column] : undefined;
};

var nextItemIsBlank = _.flow([getNextItem, p.isBlankItem]);

var nextItemIsOutOfRange = _.flow([getNextItem, _.isUndefined]);

var arrowKey = function arrowKey(_ref3) {
  var applePanel = _ref3.applePanel,
      snakePanel = _ref3.snakePanel,
      key = _ref3.key;
  var headItem = getHeadItem(snakePanel);
  var origKey = snakePanel[headItem.row][headItem.column].key;
  snakePanel[headItem.row][headItem.column].key = nextItemIsBlank(snakePanel, key) ? key : origKey;
  return {
    applePanel: applePanel,
    snakePanel: snakePanel
  };
}; // Key definition


var nop = function nop(_nop) {
  return _nop;
};

var keyFnList = [{
  key: LEFT,
  fn: arrowKey
}, {
  key: UP,
  fn: arrowKey
}, {
  key: RIGHT,
  fn: arrowKey
}, {
  key: DOWN,
  fn: arrowKey
}, {
  key: 0,
  fn: nop
}];

var isValidKey = function isValidKey(key) {
  return _.some(keyFnList, function (item) {
    return item.key === key;
  });
};

var validKey = function validKey(_ref4) {
  var applePanel = _ref4.applePanel,
      snakePanel = _ref4.snakePanel,
      key = _ref4.key;
  return {
    applePanel: applePanel,
    snakePanel: snakePanel,
    key: isValidKey(key) ? key : 0
  };
};

var storeKey = function storeKey(_ref5) {
  var applePanel = _ref5.applePanel,
      snakePanel = _ref5.snakePanel,
      key = _ref5.key;
  return _.find(keyFnList, function (item) {
    return item.key === key;
  }).fn({
    applePanel: applePanel,
    snakePanel: snakePanel,
    key: key
  });
};

var processKey = _.flow([validKey, storeKey]);

var init = function init() {
  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;
  var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
  return {
    applePanel: createApplePanel(rows, columns),
    snakePanel: createSnakePanel(rows, columns)
  };
};

var tick = function tick(state) {
  return updatePanel({
    applePanel: state.applePanel,
    snakePanel: state.snakePanel
  });
};

var key = function key(_key, state) {
  return processKey({
    applePanel: state.applePanel,
    snakePanel: state.snakePanel,
    key: _key
  });
};

var join = function join(state) {
  return p.add([state.applePanel, state.snakePanel]);
};

var toArray = function toArray(_ref6) {
  var applePanel = _ref6.applePanel,
      snakePanel = _ref6.snakePanel;
  return [_.cloneDeep(applePanel), _.cloneDeep(snakePanel)];
};

module.exports = {
  init: init,
  tick: tick,
  key: key,
  join: join,
  isBlank: p.isBlankItem,
  toArray: toArray
};